// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2Xtuw","paramInput":"JobSimulator_paramInput__1Qulx","input":"JobSimulator_input___1S7g"};